__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ui-copilot";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amplitude/analytics-browser", "^2.34.0", () => (__webpack_require__.e("vendors-node_modules_amplitude_analytics-browser_lib_esm_index_js").then(() => (() => (__webpack_require__("../../node_modules/@amplitude/analytics-browser/lib/esm/index.js"))))));
			register("react-markdown", "^10.1.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_devlop_lib_default_js-node_modules_mdast-util-to-string_lib_index_js-nod-0385f3"), __webpack_require__.e("vendors-node_modules_react-markdown_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react_jsx-runtime_react_jsx-runtime")]).then(() => (() => (__webpack_require__("../../node_modules/react-markdown/index.js"))))));
			register("react/jsx-runtime", "17.0.2", () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("node_modules_react_jsx-runtime_js")]).then(() => (() => (__webpack_require__("../../node_modules/react/jsx-runtime.js"))))));
			register("react", "17.0.2", () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__("../../node_modules/react/index.js"))))));
			register("remark-gfm", "^4.0.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_devlop_lib_default_js-node_modules_mdast-util-to-string_lib_index_js-nod-0385f3"), __webpack_require__.e("vendors-node_modules_remark-gfm_index_js")]).then(() => (() => (__webpack_require__("../../node_modules/remark-gfm/index.js"))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e("vendors-node_modules_styled-components_dist_styled-components_browser_esm_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__("../../node_modules/styled-components/dist/styled-components.browser.esm.js"))))));
			register("uuid", "^11.1.0", () => (__webpack_require__.e("vendors-node_modules_uuid_dist_esm-browser_index_js").then(() => (() => (__webpack_require__("../../node_modules/uuid/dist/esm-browser/index.js"))))));
			initExternal("webpack/container/reference/@do/current-user");
			initExternal("webpack/container/reference/@do/flippers");
			initExternal("webpack/container/reference/@do/graphql-client");
			initExternal("webpack/container/reference/@do/message-bus");
			initExternal("webpack/container/reference/@do/walrus");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};